export const TerminalMonitoringResponseMapping = {
  CANCELLED: 'CANCELLED',
  CANCELLED_FROM_TERMINAL: 'CANCELLED',
  CANCELLED_FROM_POS: 'CANCELLED',
  CANCEL_UNAVAILABLE: 'CANCELLED',
  APPROVED: 'APPROVED',
  APPROVED_WITH_ERROR: 'APPROVED',
  PRE_AUTHORIZED: 'APPROVED',
  DECLINED: 'DECLINED',
  TERMINAL_ERROR: 'ERROR',
  COULD_NOT_START_TERMINAL: 'ERROR',
  TIMEOUT: 'ERROR',
  ERROR: 'ERROR',
  PAYMENT_ALREADY_RECONCILED: 'ERROR',
  SERVICE_EXCEPTION: 'ERROR',
  NON_CANCELLABLE_STATE: 'ERROR',
  UNKNOWN: 'UNKNOWN',
};
